import { render, staticRenderFns } from "./veStuMoralCount.vue?vue&type=template&id=44a087db&scoped=true"
import script from "./veStuMoralCount.vue?vue&type=script&lang=js"
export * from "./veStuMoralCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a087db",
  null
  
)

export default component.exports